import { Flex, LinkV2, styled } from '@withjoy/joykit';

export const BANNER_HEIGHT = 56;

export const BannerWrapper = styled(Flex)`
  position: absolute;
  width: 100%;
  border-bottom: 1px solid ${props => props.theme.colors.mono3};

  height: ${BANNER_HEIGHT}px;
  top: -${BANNER_HEIGHT}px;

  animation: slideDown 1s ease-in-out 3s forwards;
  @keyframes slideDown {
    from {
      top: -${BANNER_HEIGHT}px;
    }
    to {
      top: 0px;
    }
  }
`;

export const StyledLink = styled(LinkV2)`
  display: flex;
  width: 100%;
  justify-content: center;
  gap: ${({ theme }) => theme.space[2]};
  padding: ${({ theme }) => `${theme.space[5]} ${theme.space[6]}`};

  svg > svg > path {
    fill: ${({ theme }) => theme.colors.mono14};
  }

  &:visited svg > path {
    fill: ${({ theme }) => theme.colors.linkVisited};
  }
  &:hover svg > path {
    fill: ${({ theme }) => theme.colors.linkHover};
  }
  &:active svg > path {
    fill: ${({ theme }) => theme.colors.linkActive};
  }
`;
